module.exports = __webpack_public_path__ + "static/media/loading1.546fa02d.gif";